import React from 'react'

import FormFactory from '../../../../../components/form/form-factory'
import IFormPage from '../../../../../interfaces/form-page'

import {
  Container,
  FormWrapper,
} from './styles'

type IProps = any & IFormPage

const UserEditor = ({
  dataForm,
  setData,
  onSubmit,
  errorMessage,
  initialData,
}: IProps) => (
  <Container>
    <FormWrapper>
      <FormFactory
        data={dataForm}
        onSubmit={onSubmit}
        initialData={initialData}
        submitErrorMessage={errorMessage}
        setData={setData}
      />
    </FormWrapper>
  </Container>
)

export default UserEditor
